import { render } from "./FooterHome.vue?vue&type=template&id=230552a0&scoped=true"
const script = {}

import "./FooterHome.vue?vue&type=style&index=0&id=230552a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230552a0"]])

export default __exports__